import { render } from "./RequestedOrders.vue?vue&type=template&id=ecf2e72a&scoped=true"
import script from "./RequestedOrders.vue?vue&type=script&lang=js"
export * from "./RequestedOrders.vue?vue&type=script&lang=js"

import "./RequestedOrders.vue?vue&type=style&index=0&id=ecf2e72a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecf2e72a"]])

export default __exports__